<div class="card mb-5">
    <div class="card-header">
        <h3>Histórico de Pedidos de Venta</h3>
    </div>
    <div class="card-body">
        <div class="row">
        <div class="col" id="list-container">

            <h5>Filtrar</h5>
            <div class="row g-3 align-items-end">
                <div class="col-md-6 col-sm-12 d-flex align-items-end">
                    <div class="flex-grow-1 me-2">
                    <label for="warehouse" class="form-label form-label-sm">Buscar por bodega agrupada</label>
                    <select
                        id="warehouse"
                        [(ngModel)]="selectedWarehouse"
                        class="form-select form-select-sm"
                        >
                        <option [ngValue]="null">Sin bodega asignada</option>
                        <option *ngFor="let warehouse of warehouses" [ngValue]="warehouse">
                            {{ warehouse.name }}
                        </option>
                    </select>
                    </div>
                    <button
                    class="btn btn-light btn-sm mt-1"
                    (click)="searchGrouped()"
                    title="Buscar agrupado por bodega"
                    >
                    <i class="fa fa-layer-group me-1"></i> Buscar Agrupado
                    </button>
                </div>
            </div>
            <div class="row mt-3" id="options-other-filters">
            <div class="col-sm form-group">
                <label for="filterReservations" class="form-label">Buscar</label>
                <div class="input-group">
                <input
                    type="text"
                    id="filterReservations"
                    [(ngModel)]="search"
                    placeholder="Ingresa número, cliente..."
                    class="form-control"
                />
                <button class="btn btn-primary" (click)="searching()">
                    <i class="fa fa-search"></i>
                </button>
                </div>
            </div>
            <div class="col-sm form-group">
                <label for="startDate" class="form-label">Fecha Inicio</label>
                <input type="date" [(ngModel)]="startDate" (change)="checkDateValue()" class="form-control" />
            </div>
            <div class="col-sm form-group">
                <label for="endDate" class="form-label">Fecha Final</label>
                <input type="date" [(ngModel)]="endDate" (change)="checkDateValue()" class="form-control" />
            </div>
            <div class="col-sm form-group">
                <label for="statusFilter" class="form-label">Estado</label>
                <select
                    id="statusFilter"
                    [(ngModel)]="statusFilter"
                    (change)="filterByStatus()"
                    class="form-select">
                    <option value="">Todos</option>
                    <option *ngFor="let s of statusOptions" [value]="s.label">{{ s.label }}</option>
                </select>
            </div>
            </div>

            <div class="table-responsive mt-3">
            <table class="table table-striped align-middle mb-0">
                <thead>
                <tr class="">
                    <th class="ta">Número</th>
                    <th class="ta">Bodega Solicitada</th>
                    <th class="ta">Cliente</th>
                    <th class="ta">Fecha Reserva</th>
                    <th class="ta">Fecha Expiración</th>
                    <th class="text-center">Estado</th>
                    <th class="text-center">Acciones</th>
                </tr>
                </thead>
                <tbody>
                <ng-container *ngFor="let reservation of pagination.filter; let i = index">
                    <tr>
                    <td class="ta">{{ reservation.number }}</td>
                    <td class="ta">{{ reservation.warehouseName }}</td>
                    <td class="ta">{{ reservation.clientName }}</td>
                    <td class="ta">{{ reservation.reservedDate | date: 'yyyy/MM/dd' }}</td>
                    <td class="ta">{{ reservation.expirationDate | date: 'yyyy/MM/dd' }}</td>
                        <td class="text-center">
                            <span
                                class="badge"
                                [ngClass]="getStatusColor(reservation.status)">
                                {{ reservation.status }}
                            </span>
                        </td>

                        <td class="ta">
                            <div class="d-flex gap-2 justify-content-center">
                                <button class="btn btn-sm" (click)="showDetails(reservation)">
                                    <i class="fa fa-eye"></i>
                                </button>
                                <button
                                    class="btn btn-sm"
                                    (click)="createPurchaseOrderFromReservation(reservation)"
                                    title="Convertir en Orden de Compra"
                                >
                                    <i class="fa fa-cart-plus"></i>
                                </button>
                                <button
                                *ngIf="reservation.status === statuses.TO_CONFIRMED"
                                class="btn btn-sm"
                                (click)="confirmReservation(reservation)"
                                title="Confirmar Reservación"
                                >
                                <i class="fa fa-check"></i>
                                </button>
                                <button
                                *ngIf="reservation.status === statuses.TO_CONFIRMED"
                                class="btn btn-sm"
                                (click)="cancelReservation(reservation)"
                                title="Cancelar Reservación"
                                >
                                <i class="fa fa-times"></i>
                                </button>
                            </div>
                        </td>
                    </tr>
                </ng-container>

                <tr *ngIf="pagination.filter.length == 0">
                    <td colspan="9" class="ta text-muted">
                    <i class="fa fa-circle-info"></i> No se encontraron reservaciones en el rango seleccionado
                    </td>
                </tr>
                </tbody>
            </table>
            </div>

            <app-pagination-custom [elements]="pagination"></app-pagination-custom>
        </div>
        </div>
    </div>
</div>
<app-detail-order-reservation
  *ngIf="reservationDetail"
  [showModal]="showModalDetail"
  [reservationDetail]="reservationDetail"
  [reservationDetails]="reservationDetails"
  [detailLoading]="detailLoading"
  (closed)="closeDetails($event)">
</app-detail-order-reservation>
<app-grouped-detail-order-reservation
  *ngIf="showGroupedModal"
  [showGroupedModal]="showGroupedModal"
  [groupedLoading]="groupedLoading"
  [groupedReservations]="groupedReservations"
  (closed)="closeGroupedModal($event)"
></app-grouped-detail-order-reservation>
<app-modal-create-purchase-order
    *ngIf="showPurchaseOrderModal"
    [orderShowed]="purchaseOrderData"
    [reverseTranformShowed]="true"
    (close)="closePurchaseOrderModal($event)">
</app-modal-create-purchase-order>

